import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { AppBar, Paper, useTheme } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { makeStyles } from "tss-react/mui";
import Resellers from "./admin-app/Resellers/Resellers";
import TradeReferences from "./admin-app/TradeReferences/TradeReferences";
import Preferences from "./admin-app/Preferences/Preferences";
import { checkIfRoleExists } from "../utils/oauth";
import { AppConfig, roles } from "../configs/admin-config";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: "48px",
    backgroundColor: "#f5f5f5",
    minHeight: "100vh",
    paddingBottom: 20,
  },
  container: {
    zIndex: 1,
    paddingTop: 40,
    paddingLeft: "2%",
    paddingRight: "2%",
  },
  appBar: {
    backgroundColor: theme.palette.primary.main,
  },
  tabs: {
    textTransform: "none",
    color: "white",
    padding: "12px 50px",
    "&.Mui-selected": { color: "white" },
  },
  tabs2: {
    textTransform: "none",
    marginLeft: "auto",
    textAlign: "right",
    float: "right",
    color: "white",
    padding: "12px 50px",
    "&.Mui-selected": { color: "white" },
  },
  tabPanel: {
    backgroundColor: "white",
  },
  tabPanel2: {
    backgroundColor: "white",
  },
}));

const LandingPage = (props) => {
  const { classes } = useStyles();
  const theme = useTheme();
  const history = useHistory();
  const [tabId, setTabId] = React.useState(0);

  useEffect(() => {
    // Set tab index for tabs in landing page
    if (props.match.params.tabName === "partners") {
      setTabId(0);
    } else if (props.match.params.tabName === "tradereferences") {
      setTabId(1);
    } else if (props.match.params.tabName === "preferences" && checkIfRoleExists(roles.admin)) {
      setTabId(2);
    }
  }, [props.match.params.tabName]);

  const handleChange = (event, newValue) => {
    if (newValue === 0) {
      history.replace({
        pathname: AppConfig.urls.ADMIN + AppConfig.urls.LANDING_PAGE + (AppConfig.tabs[0] ? AppConfig.tabs[0] : ""),
      });
    } else if (newValue === 1) {
      history.replace({
        pathname: AppConfig.urls.ADMIN + AppConfig.urls.LANDING_PAGE + (AppConfig.tabs[1] ? AppConfig.tabs[1] : ""),
      });
    } else if (newValue === 2) {
      history.replace({
        pathname: AppConfig.urls.ADMIN + AppConfig.urls.LANDING_PAGE + (AppConfig.tabs[2] ? AppConfig.tabs[2] : ""),
      });
    }
    setTabId(newValue);
  };

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <Paper>
          <AppBar position="static" className={classes.appBar}>
            <Tabs
              value={tabId}
              onChange={handleChange}
              scrollButtons="auto"
              textColor="inherit"
              TabIndicatorProps={{
                style: {
                  backgroundColor: theme.palette.secondary.main,
                  height: 3,
                },
              }}
            >
              <Tab className={classes.tabs} label="Partners" />
              <Tab className={classes.tabs} label="Trade References" />
              <Tab
                className={classes.tabs2}
                label="Preferences"
                disabled={!checkIfRoleExists(roles.admin)}
              />
            </Tabs>
          </AppBar>
          <TabPanel className={classes.tabPanel} value={tabId} index={0}>
            <Resellers />
          </TabPanel>
          <TabPanel className={classes.tabPanel} value={tabId} index={1}>
            <TradeReferences />
          </TabPanel>
          <TabPanel className={classes.tabPanel2} value={tabId} index={2}>
            <Preferences />
          </TabPanel>
        </Paper>
      </div>
    </div>
  );
};

export default LandingPage;
